export default "__VITE_ASSET__DJ5y63j1__"